import axios from "axios";
axios.defaults.baseURL = "https://back.freebrokers.online";
export default axios;
